// prettier-ignore
export const firebaseConfig = {
apiKey: "AIzaSyA3gq7ATAScDY7ab7qyAywy9cgFpzq4w1U", authDomain: "pruforce-fc8b8.firebaseapp.com",projectId: "pruforce-fc8b8",storageBucket: "pruforce-fc8b8.appspot.com",messagingSenderId: "618021898898",appId: "1:618021898898:web:4a7cbcc1588e7a2818f44b", measurementId: "G-RWVE98F288"
};
